
import type { LoginRootState } from '../types';

export const selectIsLoggedIn = (state: LoginRootState) => state.login.isLoggedIn;
export const selectEmail = (state: LoginRootState) => state.login.email;
export const selectLoginError = (state: LoginRootState) => state.login.error;
export const selectIsLoading = (state: LoginRootState) => state.login.isLoading;
export const selectAccessToken = (state: LoginRootState) => state.login.accessToken;

export type { LoginRootState };

